import { useEffect, useState } from "react";
import { MailWarning } from "lucide-react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";

// Shows on Approval + Campaigns when the workspace has no live mailbox connected.
export function ManualSendBanner() {
  const [manual, setManual] = useState(false);
  const navigate = useNavigate();
  useEffect(() => { api.get("/org/status").then((r) => setManual(!!r.data.manual_send)).catch(() => {}); }, []);
  if (!manual) return null;
  return (
    <div className="rounded-xl border border-sky-500/30 bg-sky-500/5 p-4 mb-6 flex items-start gap-3" data-testid="manual-send-banner">
      <MailWarning className="h-5 w-5 text-sky-500 shrink-0 mt-0.5" />
      <div className="flex-1">
        <p className="text-sm text-foreground">Sending from your own inbox. Connect Google or Outlook when you want DealsOps to send.</p>
      </div>
      <button onClick={() => navigate("/app/settings/integrations")} className="text-xs font-medium text-sky-500 hover:underline shrink-0 mt-0.5" data-testid="manual-banner-connect">Connect email</button>
    </div>
  );
}
